import { store } from './stores/mainStore';

export class MiddleLayer {
	constructor(connection, r7Data) {
		this.connection = connection;
		this.r7Data = r7Data;
	}

	Login() {
		return this.connection.CallRoute('auth/login', this.r7Data)
	}

	GetMe() {
		return this.connection.CallRoute('me', {}, 'GET')
	}
	GetPaytable() {
		return this.connection.CallRoute('paytable', {}, 'GET')
	}

	CheckOngoing () {
		return this.connection.CallRoute('ongoing-game', {}, 'GET')
	}
	SendSeen () {
		return this.connection.CallRoute('seen-game', {}, 'PUT')
	}

	ResetTutorial(tutorial) {
		this.tutorialConnection = tutorial;
	}
	FinishTutorial(pay) {
		return Promise.resolve();
	}

	CreateMatch = (bet) => {
		return this.connection.CallRoute('games', {
			betAmount: bet,
			type: this.r7Data.gameId,
			mode: this.r7Data.casinoId
		});
	};

	GetMatch = (id) => {
		var payload = {
			MatchId: id,
		};

		var c = store.tutorialMode ? this.tutorialConnection : this.connection;

		return c.CallRoute('get-match', payload).then((data) => {
			if (data.ErrorCode) {
				return data;
			}
			data.Payload.Match.MatchId = id;
			if (data.Payload.Match.Opponents && data.Payload.Match.Opponents.length) {
				data.Payload.Match.OpponentMatchRounds = data.Payload.Match.Opponents[0].MatchRounds;
			}
			if (data.Payload.Match.Opponents.length && data.Payload.OpponentSummary) {
				data.Payload.Match.Opponents[0].summary = data.Payload.OpponentSummary;
			}
			return data;
		});
	};


	ContinueRoll = (held) => {
		return this.connection.CallRoute('roll-dice', {
			holdIndexes: held,
		});
	};
	CompleteHand(id, selection) {
		var payload = {
			MatchId: id,
		};
		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute('keep-hand', payload);
	}

	UseFreeRoll(matchId) {
		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute('apply-free-roll', {
			MatchId: matchId,
		});
	}
	UseHandReset(matchId) {
		return this.connection.CallRoute('apply-hand-reset', {
			MatchId: matchId,
		});
	}
}
